document.body.classList.toggle('js-enabled');

// Fermeture du menu
jQuery('.close_menu').click(function () {
  jQuery('.MenuFullWidth__content-wrapper').hide();
  jQuery('.close_menu').hide();
  jQuery('body').removeClass('burger-activated');
  jQuery('html').removeClass('menu-open');
});

// Ouverture du menu
jQuery('body').on('click', '.button--menu', function () {
  jQuery('body').addClass('burger-activated');
  jQuery('.close_menu').show();
  jQuery('.MenuFullWidth__content-wrapper').show();
  jQuery('html').addClass('menu-open'); 
  console.log('fadeIn');
});

